"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
var react_1 = __importDefault(require("react"));
var PaginationIcon = function (props) {
    var getRootElement = function (children) {
        switch (props.rootElement) {
            case "Div":
                return react_1.default.createElement("div", { className: props.rootElementClassName }, children);
            case "Span":
                return react_1.default.createElement("span", { className: props.rootElementClassName }, children);
        }
    };
    var getSize = function () {
        switch (props.size) {
            case "Small":
                return "16px";
            case "Medium":
                return "24px";
            case "Large":
                return "32px";
            case "X-Large":
                return "40px";
            case "XX-Large":
                return "48px";
        }
    };
    var getIcon = function () {
        switch (props.icon) {
            case IconType.Close:
                return (react_1.default.createElement("svg", { className: props.className, onClick: props.onClick, width: getSize(), height: getSize(), version: "1.1", viewBox: "175 100 350 350", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("g", { fillRule: "evenodd" },
                        react_1.default.createElement("path", { fill: "currentColor", d: "m237.93 130.9 259.74 259.74-32.465 32.469-259.74-259.74z" }),
                        react_1.default.createElement("path", { fill: "currentColor", d: "m465.2 130.9 32.465 32.469-259.74 259.74-32.465-32.469z" }))));
        }
    };
    return react_1.default.createElement(react_1.default.Fragment, null, getRootElement(getIcon()));
};
exports.default = PaginationIcon;
// eslint-disable-next-line no-shadow
var IconType;
(function (IconType) {
    IconType["Close"] = "Close";
})(IconType = exports.IconType || (exports.IconType = {}));
